import * as o from "react";
import a from "../lib/IconBase.es.js";
import m from "../defs/Cloud.es.js";
const e = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(a, { ref: t, ...r, weights: m }));
e.displayName = "CloudIcon";
const n = e;
export {
  n as Cloud,
  e as CloudIcon
};
